// JSA V1 Fall Protection Inspection List and Fall Protection Classes.
import { v4 as uuidv4 } from "uuid";

// JsaFallProtectionInspectionList
export class JsaFallProtectionInspectionList {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.equipmentSerialNumber = data.equipment_serial_number || "";
    this.hardwareInspectionAccept = data.hardware_inspection_accept || false;
    this.hardwareInspectionReject = data.hardware_inspection_reject || false;
    this.webbingInspectionAccept = data.webbing_inspection_accept || false;
    this.webbingInspectionReject = data.webbing_inspection_reject || false;
    this.stitchingInspectionAccept = data.stitching_inspection_accept || false;
    this.stitchingInspectionReject = data.stitching_inspection_reject || false;
    this.syntheticRopeInspectionAccept =
      data.synthetic_rope_inspection_accept || false;
    this.syntheticRopeInspectionReject =
      data.synthetic_rope_inspection_reject || false;
    this.wireRopeInspectionAccept = data.wire_rope_inspection_accept || false;
    this.wireRopeInspectionReject = data.wire_rope_inspection_reject || false;
    this.energyAbsorbInspectionAccept =
      data.energy_absorb_inspection_accept || false;
    this.energyAbsorbInspectionReject =
      data.energy_absorb_inspection_reject || false;
    this.labelsInspectionAccept = data.labels_inspection_accept || false;
    this.labelsInspectionReject = data.labels_inspection_reject || false;
  }

  // Update the fall protection inspection list items
  updateEquipmentSn(value) {
    this.equipmentSerialNumber = value;
  }

  updateHardwareInspectionAccept(value) {
    if (!value) {
      this.hardwareInspectionAccept = false;
    } else {
      this.hardwareInspectionAccept = value;
      this.hardwareInspectionReject = false;
    }
  }

  updateHardwareInspectionReject(value) {
    if (!value) {
      this.hardwareInspectionReject = false;
    } else {
      this.hardwareInspectionReject = value;
      this.hardwareInspectionAccept = false;
    }
  }

  updateWebbingInspectionAccept(value) {
    if (!value) {
      this.webbingInspectionAccept = false;
    } else {
      this.webbingInspectionAccept = value;
      this.webbingInspectionReject = false;
    }
  }

  updateWebbingInspectionReject(value) {
    if (!value) {
      this.webbingInspectionReject = false;
    } else {
      this.webbingInspectionReject = value;
      this.webbingInspectionAccept = false;
    }
  }

  updateStitchingInspectionAccept(value) {
    if (!value) {
      this.stitchingInspectionAccept = false;
    } else {
      this.stitchingInspectionAccept = value;
      this.stitchingInspectionReject = false;
    }
  }

  updateStitchingInspectionReject(value) {
    if (!value) {
      this.stitchingInspectionReject = false;
    } else {
      this.stitchingInspectionReject = value;
      this.stitchingInspectionAccept = false;
    }
  }

  updateSyntheticRopeInspectionAccept(value) {
    if (!value) {
      this.syntheticRopeInspectionAccept = false;
    } else {
      this.syntheticRopeInspectionAccept = value;
      this.syntheticRopeInspectionReject = false;
    }
  }

  updateSyntheticRopeInspectionReject(value) {
    if (!value) {
      this.syntheticRopeInspectionReject = false;
    } else {
      this.syntheticRopeInspectionReject = value;
      this.syntheticRopeInspectionAccept = false;
    }
  }

  updateWireRopeInspectionAccept(value) {
    if (!value) {
      this.wireRopeInspectionAccept = false;
    } else {
      this.wireRopeInspectionAccept = value;
      this.wireRopeInspectionReject = false;
    }
  }

  updateWireRopeInspectionReject(value) {
    if (!value) {
      this.wireRopeInspectionReject = false;
    } else {
      this.wireRopeInspectionReject = value;
      this.wireRopeInspectionAccept = false;
    }
  }

  updateEnergyAbsorbInspectionAccept(value) {
    if (!value) {
      this.energyAbsorbInspectionAccept = false;
    } else {
      this.energyAbsorbInspectionAccept = value;
      this.energyAbsorbInspectionReject = false;
    }
  }

  updateEnergyAbsorbInspectionReject(value) {
    if (!value) {
      this.energyAbsorbInspectionReject = false;
    } else {
      this.energyAbsorbInspectionReject = value;
      this.energyAbsorbInspectionAccept = false;
    }
  }

  updateLabelsInspectionAccept(value) {
    if (!value) {
      this.labelsInspectionAccept = false;
    } else {
      this.labelsInspectionAccept = value;
      this.labelsInspectionReject = false;
    }
  }

  updateLabelsInspectionReject(value) {
    if (!value) {
      this.labelsInspectionReject = false;
    } else {
      this.labelsInspectionReject = value;
      this.labelsInspectionAccept = false;
    }
  }

  // To json for sending to the database
  toJson() {
    return {
      id: this.rowId,
      equipment_serial_number: this.equipmentSerialNumber,
      hardware_inspection_accept: this.hardwareInspectionAccept,
      hardware_inspection_reject: this.hardwareInspectionReject,
      webbing_inspection_accept: this.webbingInspectionAccept,
      webbing_inspection_reject: this.webbingInspectionReject,
      stitching_inspection_accept: this.stitchingInspectionAccept,
      stitching_inspection_reject: this.stitchingInspectionReject,
      synthetic_rope_inspection_accept: this.syntheticRopeInspectionAccept,
      synthetic_rope_inspection_reject: this.syntheticRopeInspectionReject,
      wire_rope_inspection_accept: this.wireRopeInspectionAccept,
      wire_rope_inspection_reject: this.wireRopeInspectionReject,
      energy_absorb_inspection_accept: this.energyAbsorbInspectionAccept,
      energy_absorb_inspection_reject: this.energyAbsorbInspectionReject,
      labels_inspection_accept: this.labelsInspectionAccept,
      labels_inspection_reject: this.labelsInspectionReject,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const fieldMap = {
      equipmentSerialNumber: "equipment_serial_number",
      hardwareInspectionAccept: "hardware_inspection_accept",
      hardwareInspectionReject: "hardware_inspection_reject",
      webbingInspectionAccept: "webbing_inspection_accept",
      webbingInspectionReject: "webbing_inspection_reject",
      stitchingInspectionAccept: "stitching_inspection_accept",
      stitchingInspectionReject: "stitching_inspection_reject",
      syntheticRopeInspectionAccept: "synthetic_rope_inspection_accept",
      syntheticRopeInspectionReject: "synthetic_rope_inspection_reject",
      wireRopeInspectionAccept: "wire_rope_inspection_accept",
      wireRopeInspectionReject: "wire_rope_inspection_reject",
      energyAbsorbInspectionAccept: "energy_absorb_inspection_accept",
      energyAbsorbInspectionReject: "energy_absorb_inspection_reject",
      labelsInspectionAccept: "labels_inspection_accept",
      labelsInspectionReject: "labels_inspection_reject",
    };

    const patch = {
      patch_type: "jsa_fall_protection_inspection_list",
      jsa_id: jsaId,
      id: this.rowId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }

    return patch;
  }
}

// JsaFallProtection

export class JsaFallProtection {
  constructor(data = {}) {
    this.fpEquipReqYes = data.fp_equip_req_yes || false;
    this.fpEquipReqNo = data.fp_equip_req_no || false;
    this.fpEquipBodyHarness = data.fp_equip_body_harness || false;
    this.fpEquipShockLanyard = data.fp_equip_shock_lanyard || false;
    this.fpEquipRetracLanyard = data.fp_equip_retrac_lanyard || false;
    this.fpEquipOtherInfo = data.fp_equip_other_info || "";
    // Fall Protection Inspection List
    this.fallProtectionInspectionList = data.fall_protection_inspection
      ? data.fall_protection_inspection.map(
          (inspection) => new JsaFallProtectionInspectionList(inspection)
        )
      : [];
  }

  // Update functions
  resetFallProtectionInfo() {
    // Reset the fall protection inspection list
    this.fallProtectionInspectionList = [];
    // Reseting the rest of the fall protection info
    this.fpEquipReqYes = false;
    this.fpEquipBodyHarness = false;
    this.fpEquipShockLanyard = false;
    this.fpEquipRetracLanyard = false;
    this.fpEquipOtherInfo = "";
  }

  // Update the fall protection equipment required yes/no
  updateFpEquipReqYes(value) {
    if (!value) {
      this.fpEquipReqYes = false;
      this.resetFallProtectionInfo();
    } else {
      this.fpEquipReqYes = value;
      this.fpEquipReqNo = false;
    }
  }

  // Update the fall protection equipment required no
  updateFpEquipReqNo(value) {
    if (!value) {
      this.fpEquipReqNo = false;
    } else {
      this.fpEquipReqNo = value;
      this.resetFallProtectionInfo();
    }
  }

  // Update the fall protection equipment required body harness
  updateFpEquipBodyHarness(value) {
    this.fpEquipBodyHarness = value;
  }

  // Update the fall protection equipment required shock lanyard
  updateFpEquipShockLanyard(value) {
    this.fpEquipShockLanyard = value;
  }

  // Update the fall protection equipment required retrac lanyard
  updateFpEquipRetracLanyard(value) {
    this.fpEquipRetracLanyard = value;
  }

  // Update the fall protection equipment required other info
  updateFpEquipOtherInfo(value) {
    this.fpEquipOtherInfo = value;
  }

  // Update the fall protection inspection list functions
  addFallProtectionInspectionListItem() {
    const newItem = new JsaFallProtectionInspectionList();
    this.fallProtectionInspectionList.push(newItem);
    return newItem;
  }

  // Remove the fall protection inspection list
  removeFallProtectionInspectionList(inspection) {
    this.fallProtectionInspectionList =
      this.fallProtectionInspectionList.filter(
        (item) => item.rowId !== inspection.rowId
      );
  }

  // Update fall protection inspection list item
  updateFallProtectionInspectionListItemEquipmentSn(inspection, value) {
    const inspectionItem = this.fallProtectionInspectionList.find(
      (item) => item.rowId === inspection.rowId
    );
    if (inspectionItem) {
      inspectionItem.updateEquipmentSn(value);
    }
    return inspectionItem;
  }

  updateFallProtectionInspectionListItemAcceptReject(
    inspection,
    inspectionType,
    value
  ) {
    const inspectionItem = this.fallProtectionInspectionList.find(
      (item) => item.rowId === inspection.rowId
    );
    if (inspectionItem) {
      inspectionItem[`update${inspectionType}`](value);
    }
    return inspectionItem;
  }

  // To json for sending to the database
  toJson() {
    return {
      fp_equip_req_yes: this.fpEquipReqYes,
      fp_equip_req_no: this.fpEquipReqNo,
      fp_equip_body_harness: this.fpEquipBodyHarness,
      fp_equip_shock_lanyard: this.fpEquipShockLanyard,
      fp_equip_retrac_lanyard: this.fpEquipRetracLanyard,
      fp_equip_other_info: this.fpEquipOtherInfo,
    };
  }

  // ToJson for the fall protection inspection list
  toJsonFallProtectionInspectionList() {
    return this.fallProtectionInspectionList.map((inspection) =>
      inspection.toJson()
    );
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const fieldMap = {
      fpEquipReqYes: "fp_equip_req_yes",
      fpEquipReqNo: "fp_equip_req_no",
      fpEquipBodyHarness: "fp_equip_body_harness",
      fpEquipShockLanyard: "fp_equip_shock_lanyard",
      fpEquipRetracLanyard: "fp_equip_retrac_lanyard",
      fpEquipOtherInfo: "fp_equip_other_info",
    };

    const patch = {
      patch_type: "jsa_fall_protection",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }

    return patch;
  }
}
